<template>
    <div class="pr-5">
        <editor-js
            :data="data.areas[0].content"
            @save="(d) => save(0, d)"
        />

        <div class="field-frame">
            <b-input expanded></b-input>
            <b-switch class="mt-3" v-model="data.required">Response Required</b-switch>
        </div>

        <editor-js
            :data="data.areas[1].content"
            @save="(d) => save(1, d)"
        />

        <advanced-options :data="data"/>
    </div>
</template>

<script>
    import {client as http} from "@/http_client";

    import 'video.js/dist/video-js.css'
    import EditorJs from "../EditorJs.vue";
    import AdvancedOptions from "./AdvancedOptions.vue";

    import { v4 as uuidv4 } from 'uuid';


    export default {
        components: {EditorJs, AdvancedOptions},
        props: ['data'],
        data: function() {
            return {

            }
        },
        computed: {

        },
        methods: {
            save(area, data) {
                this.data.areas[area].content = data;
            }
        },
        created() {
            if (!this.data.areas) {
                this.data.areas = [
                    {areas: 1, content: null, attributes: {}},
                    {areas: 2, content: null, attributes: {}},
                ];

                this.data.title = "";
                this.data.required = false;
                this.data.id = uuidv4();
            }
        }
    };
</script>

<style lang="scss">
    .field-frame {
        border-radius: 5px;
        margin: 0 0 1rem 2rem;
        //border: 1px solid #e7e7e7;
        //padding: 10px;

    }
</style>
